export default "https://cdn-static.gokick.com/assets/9175df2ab050434674d4a27e4dae3ab0ebb22d80/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";